import React from 'react';
import {useTranslation} from 'react-i18next';
import {isFieldDiff} from '../shapes';
import {HIDDEN_FIELDS} from '../labels';
import {describeDiff} from '../diff_field_types';
import {DeltaChip} from './DeltaChip';

// Lista de cambios "viejo → NUEVO" (patrón ②b del detalle). `changes` es el mapa
// {campo: {before, after}}; `fieldOrder` opcional fija el orden de las filas (y es la única
// lista que se renderiza: quien la arma es responsable de no perder campos).
//
// Props de moneda: `currency` aplica a los dos lados; `currencyBefore`/`currencyAfter`
// permiten que cada lado vaya con la suya cuando el cambio ES de moneda (ahí el delta se
// suprime solo: montos en monedas distintas no son comparables). `showDelta={false}` apaga
// el chip a mano.
export function DiffList({changes, fieldOrder, currency, currencyBefore, currencyAfter, showDelta = true}) {
    const {t} = useTranslation();
    if (!changes || typeof changes !== 'object') return null;

    const fields = (fieldOrder || Object.keys(changes))
        .filter(field => !HIDDEN_FIELDS.has(field) && isFieldDiff(changes[field]));
    if (!fields.length) return null;

    const currencies = {currency, currencyBefore, currencyAfter};

    return (
        <div className="ald-diff">
            {fields.map(field => {
                const {label, before, after, delta} = describeDiff(field, changes[field], t, currencies);
                return (
                    <div className="ald-diff-row" key={field}>
                        <span className="ald-diff-label">{label}</span>
                        <span className="ald-diff-values">
                            <span className="ald-diff-before">{before}</span>
                            <span className="ald-diff-arrow" aria-hidden="true">→</span>
                            <span className="ald-diff-after">{after}</span>
                            {showDelta && delta
                                ? <DeltaChip before={delta.before} after={delta.after} money currency={delta.currency}/>
                                : null}
                        </span>
                    </div>
                );
            })}
        </div>
    );
}

// UN solo cambio: la lista es ruido (una fila sola con su label a la izquierda), la frase se
// lee de un tirón. Misma humanización que las filas — sale del mismo describeDiff.
export function DiffStory({field, change, currency, currencyBefore, currencyAfter, showDelta = true}) {
    const {t} = useTranslation();
    if (!isFieldDiff(change)) return null;

    const {label, before, after, delta} = describeDiff(field, change, t, {currency, currencyBefore, currencyAfter});
    return (
        <div className="ald-story">
            {t('activity_log.detail.single_change', {
                field: label,
                before,
                after,
                interpolation: {escapeValue: false},
            })}
            {showDelta && delta ? (
                <React.Fragment>
                    {' '}
                    <DeltaChip before={delta.before} after={delta.after} money currency={delta.currency}/>
                </React.Fragment>
            ) : null}
        </div>
    );
}
